const dbName = "text-db";
const defaultName = "default";

// Open the database
function openDB(): Promise<IDBDatabase> {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(dbName, 1);
        request.onupgradeneeded = () => {
            const db = request.result;
            if (!db.objectStoreNames.contains(defaultName)) {
                db.createObjectStore(defaultName);
            }
        };
        request.onsuccess = () => resolve(request.result);
        request.onerror = () => reject(request.error);
    });
}

/**
 * Saves a text file to IndexedDB.
 */
export async function saveTextFile(
    filename: string,
    data: string,
): Promise<void> {
    if(!filename || !data) return;

    const db = await openDB();
    const tx = db.transaction(defaultName, "readwrite");
    tx.objectStore(defaultName).put(data, filename);
    await new Promise((resolve, reject) => {
        tx.oncomplete = resolve;
        tx.onerror = reject;
    });
}

/**
 * Loads a text file from IndexedDB.
 */
export async function loadTextFile(
    filename: string,
): Promise<string | null> {

    const db = await openDB();
    return new Promise((resolve, reject) => {
        try {
            const tx = db.transaction(defaultName, "readonly");
            const request = tx.objectStore(defaultName).get(filename);
            request.onsuccess = () => resolve(request.result ?? null);
            request.onerror = () => reject(request.error);
        } catch (error) {
            console.error(error);
        }
    });
}

/**
 * Removes a text file from IndexedDB.
 */
export async function removeTextFile(
    filename: string,
): Promise<void> {
    const db = await openDB();
    const tx = db.transaction(defaultName, "readwrite");
    tx.objectStore(defaultName).delete(filename);
    await new Promise((resolve, reject) => {
        tx.oncomplete = resolve;
        tx.onerror = reject;
    });
}

/**
 * Lists all text file names in IndexedDB.
 */
export async function listTextFiles(): Promise<string[]> {
    const db = await openDB();
    return new Promise((resolve, reject) => {
        const tx = db.transaction(defaultName, "readonly");
        const request = tx.objectStore(defaultName).getAllKeys();

        console.log(request);

        request.onsuccess = () => resolve(request.result as string[]);
        request.onerror = () => reject(request.error);
    });
}
